import PageNotFound from './helpers/PageNotFound'
import NoConfiguration from './helpers/NoConfiguation'

import Messages from './private/messages/Messages'
import Profile from './private/profile/Profile'
import Expert from './public/expert/Expert'
import Experts from './public/experts/Experts'
import Perks from './public/perks/Perks'

import LoginPage from './public/login/LoginPage'
import RegisterPage from './public/register/RegisterPage'
import Onboarding from './private/onboarding/Onboarding'

export enum RoutePath {
	Base = '/',
	NotFound = '*',

	Call = '/call/:id',

	Login = '/login',
	Register = '/register',
	linkedin = '/linkedin',

	Experts = '/experts',
	ExpertsFilter = '/experts/:filter/:slug?',
	Expert = '/expert/:slug',

	Perks = '/perks',
	Profile = '/profile',
	Account = '/account/:accountId',
	Messages = '/messages/:id?',
	NoConfiguration = '/no-configuration',
	Onboarding = '/onboarding',
}

export const routes = [
	{
		path: RoutePath.Base,
		exact: true,
		redirectTo: RoutePath.Experts,
	},
	{
		path: RoutePath.Login,
		component: LoginPage,
		public: true,
	},
	{
		path: RoutePath.Register,
		component: RegisterPage,
		public: true,
	},
	{
		path: RoutePath.Experts,
		component: Experts,
		exact: true,
	},
	{
		path: RoutePath.Perks,
		component: Perks,
		exact: true,
	},
	{
		path: RoutePath.ExpertsFilter,
		component: Experts,
		exact: true,
	},
	{
		path: RoutePath.Expert,
		component: Expert,
	},
	{
		path: RoutePath.Profile,
		component: Profile,
		private: true,
	},
	{
		path: RoutePath.Account,
		component: Profile,
		private: true,
	},
	{
		path: RoutePath.Messages,
		component: Messages,
		private: true,
	},
	{
		path: RoutePath.Onboarding,
		component: Onboarding,
		private: true,
	},
	{
		path: RoutePath.NoConfiguration,
		component: NoConfiguration,
	},
	{
		path: RoutePath.NotFound,
		component: PageNotFound,
		exact: true,
	},
]
